import { transferToken, getCompanyNameKey, getSubdomain } from '@/auth'
import { CAMPAIGN_URL } from '@/consts'

export const useCreateExternalLink = async (
  url: string,
  productType: string,
  returnPath?: string
): Promise<string> => {
  const subdomain = await getSubdomain()
  const transferKey = await transferToken()
  const companyNameKey = await getCompanyNameKey()

  if (!subdomain) {
    throw new Error('Failed to get subdomain')
  }

  if (!transferKey?.TransferKey) {
    throw new Error('Failed to get transfer key')
  }

  if (!companyNameKey) {
    throw new Error('Failed to get company name key')
  }

  let link = ''
  switch (productType) {
    case 'fast': {
      // Auth transfer must go through /users/attensi: it consumes the
      // transfer_key, signs the user in (sets the Devise session), then
      // redirects to redirect_path. Hitting the editor route directly
      // bypasses transfer-key auth and bounces to the login page.
      const params = new URLSearchParams({
        subdomain,
        transfer_key: transferKey.TransferKey,
        company_name_key: companyNameKey,
      })
      if (returnPath) {
        params.set('redirect_path', returnPath)
      }
      link = `${url}/users/attensi?${params.toString()}`
      break
    }
    case 'new-insights': {
      // Build callback URL with return_url pointing to the target path
      const callbackUrl = new URL('/auth/callback-client', url)
      callbackUrl.searchParams.set('subdomain', subdomain)
      callbackUrl.searchParams.set('transfer_key', transferKey.TransferKey)
      callbackUrl.searchParams.set('company_name_key', companyNameKey)
      if (returnPath) {
        callbackUrl.searchParams.set('return_url', returnPath)
      }

      link = callbackUrl.toString()
      break
    }
    default:
      link = `${url}/${subdomain}/?subdomain=${subdomain}&transfer_key=${transferKey.TransferKey}&company_name_key=${companyNameKey}`
      break
  }
  return link
}

export const useCreateNewCampaignPresetLink = async (
  newCampaignId: string,
  presetId: string,
  customUserList: boolean
): Promise<string> => {
  const subdomain = await getSubdomain()
  const transferKey = await transferToken()
  const companyNameKey = await getCompanyNameKey()

  if (!subdomain) {
    throw new Error('Failed to get subdomain')
  }

  if (!transferKey?.TransferKey) {
    throw new Error('Failed to get transfer key')
  }

  if (!companyNameKey) {
    throw new Error('Failed to get company name key')
  }

  return `${CAMPAIGN_URL}/${subdomain}/campaigns/new${
    customUserList ? '-custom' : ''
  }/${newCampaignId}?presetId=${presetId}&subdomain=${subdomain}&transfer_key=${
    transferKey.TransferKey
  }&company_name_key=${companyNameKey}`
}
